export default __webpack_public_path__ + "static/media/home.fbfd373b.png";